// Model ARN constants
export const CLAUDE_45_SONNET_MODEL_ID = 'arn:aws:bedrock:eu-central-1:586794487615:inference-profile/eu.anthropic.claude-sonnet-4-5-20250929-v1:0';
export const CLAUDE_37_SONNET_MODEL_ID = 'arn:aws:bedrock:eu-central-1::inference-profile/eu.anthropic.claude-3-7-sonnet-20250219-v1:0';
export const NOVA_PRO_MODEL_ID = 'arn:aws:bedrock:eu-central-1:586794487615:inference-profile/eu.amazon.nova-pro-v1:0';

/**
 * Get the appropriate model ID based on the organization's AI model setting
 * @param aiModel - The AI model tier from organisation settings ('Premium', 'Premium Small', or 'Standard')
 * @returns The model ARN to use for API calls
 */
export function getModelIdForOrganization(aiModel: string = 'Premium'): string {
  if (aiModel === 'Standard') {
    return NOVA_PRO_MODEL_ID;
  } else if (aiModel === 'Premium Small') {
    return CLAUDE_45_SONNET_MODEL_ID; // Same model, different context
  }
  // Default to Premium (Claude 4.5 Sonnet with 1M context)
  return CLAUDE_45_SONNET_MODEL_ID;
}

/**
 * Check if this tier uses beta headers for 1M context
 * @param aiModel - The AI model tier
 * @returns Whether beta headers should be included
 */
export function usesBetaHeaders(aiModel: string = 'Premium'): boolean {
  return aiModel === 'Premium';
}

/**
 * Get the fallback model ID for rate limiting scenarios
 * @param aiModel - The AI model tier from organisation settings
 * @returns The fallback model ARN
 */
export function getFallbackModelId(aiModel: string = 'Premium'): string {
  // For both Premium and Standard, fallback to Claude 3.7
  return CLAUDE_37_SONNET_MODEL_ID;
}

